__turbopack_context__.v({
  "btn": "CalendarTicketPopUp-module-scss-module__haeKDG__btn",
  "close": "CalendarTicketPopUp-module-scss-module__haeKDG__close",
  "datePicker": "CalendarTicketPopUp-module-scss-module__haeKDG__datePicker",
  "modal": "CalendarTicketPopUp-module-scss-module__haeKDG__modal",
  "modalLink": "CalendarTicketPopUp-module-scss-module__haeKDG__modalLink",
  "popupBody": "CalendarTicketPopUp-module-scss-module__haeKDG__popupBody",
  "selected": "CalendarTicketPopUp-module-scss-module__haeKDG__selected",
  "visuallyHidden": "CalendarTicketPopUp-module-scss-module__haeKDG__visuallyHidden",
});
